import { definePreset, palette } from '@primeng/themes';
import Aura from '@primeng/themes/aura';

const GCMPreset = definePreset(Aura, {
  semantic: {
    colorScheme: {
      light: {
        primary: {
          ...palette('{indigo}'),
          700: '#204496',
          color: '{primary.700}',
          hoverColor: '#2856B0',
          contrastColor: '#ffffff'
        },
        surface: palette('{slate}')
      },
    },
  },
  components: {
    button: {
        colorScheme: {
            light: {
                text: {
                  secondary: {
                    color: '{surface.700}'
                  }
                }
            }
        }
    }
}
});

export default GCMPreset;
